// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expressionEditor_PVmv7 {
  width: 400px;
  min-height: 240px;
  margin-left: 8px;
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/filter/RsrcFilterModelEditor.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".expressionEditor {\n  width: 400px;\n  min-height: 240px;\n  margin-left: 8px;\n  margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expressionEditor": `expressionEditor_PVmv7`
};
export default ___CSS_LOADER_EXPORT___;
